/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuestAuthenticationEnum } from "./GuestAuthenticationEnum";
export const EnvironmentConfigUpdate = core.serialization.object({
    name: core.serialization.string().optional(),
    isProd: core.serialization.boolean().optional(),
    guestAuthentication: core.serialization.list(GuestAuthenticationEnum).optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    translationsPath: core.serialization.string().optional(),
    namespaces: core.serialization.list(core.serialization.string()).optional(),
    languageOverride: core.serialization.string().optional(),
});
